<p>
  <mat-icon fontSet="fa" fontIcon="fa-long-arrow-alt-right"></mat-icon>
  <a target="_blank" href="{{ link }}">{{ message }}</a>
</p>
